import React, { Component } from 'react';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import Footer from './Footer';
import Banner from './Banner';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as AppManager from '../../reducers/ui/app';
import BannerPending from './BannerPending';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type State = {};

class PaymentSuccessPageComponent extends Component<PropsFromRedux, State> {
	state = {};

	renderBanner = () => {
		if (this.props.paymentStatus === 'finished') return <Banner />;
		if (this.props.paymentStatus === 'pending') return <BannerPending />;
	};

	render() {
		return (
			<PageWrapper>
				<Navbar variant="blue" />
				{this.renderBanner()}
				<Footer />
			</PageWrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		paymentStatus: AppManager.Selectors.getPaymentStatus(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const PaymentSuccessPage = connector(PaymentSuccessPageComponent);
export default PaymentSuccessPage;
